import { render, staticRenderFns } from "./RegisterTravelCard.vue?vue&type=template&id=e90025da"
import script from "./RegisterTravelCard.vue?vue&type=script&lang=ts"
export * from "./RegisterTravelCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports